export default {
  form: {
    display: 'none'
  }
}
